import { CookieService } from 'ngx-cookie-service';

import { CookieStore } from './implementations/cookie-store/cookie-store.service';
import { GDPRPolicy } from './implementations/gdpr-policy/gdpr-policy.service';
import { NoopPolicy } from './implementations/noop-policy/noop-policy.service';
import type { IPersonalDataProtectionStorage } from './interfaces/personal-data-protection-persistence.storage';
import { PERSONAL_DATA_PROTECTION_STORAGE } from './interfaces/personal-data-protection-persistence.storage';
import type { IPersonalDataProtectionPolicy } from './interfaces/personal-data-protection-policy.interface';
import { PERSONAL_DATA_PROTECTION_POLICY } from './interfaces/personal-data-protection-policy.interface';
import { DEFAULT_CONSENT_TYPE } from './tokens';

export function defaultPersonalDataProtectionPolicyFactory(
    store: IPersonalDataProtectionStorage,
    cookieService: CookieService
): IPersonalDataProtectionPolicy {
    if (cookieService.get('is_eu_visitor') === '1') {
        return new GDPRPolicy(store);
    }

    return new NoopPolicy();
}

export const DEFAULT_PERSONAL_DATA_PROTECTION_PROVIDERS = [
    { provide: PERSONAL_DATA_PROTECTION_STORAGE, useClass: CookieStore },
    {
        provide: PERSONAL_DATA_PROTECTION_POLICY,
        useFactory: defaultPersonalDataProtectionPolicyFactory,
        deps: [PERSONAL_DATA_PROTECTION_STORAGE, CookieService],
    },
    {
        provide: DEFAULT_CONSENT_TYPE,
        useValue: 'default',
    },
];
